import api from '../api/apiClient'
import type {
  NotificationsResponse,
  UnreadCountResponse,
  NotificationResponse,
  MarkAsReadResponse,
  MarkAllAsReadResponse,
  GetNotificationsParams,
  NotificationType
} from '../models/notification'

export const notificationsRepository = {
  getAllNotifications: async (params?: GetNotificationsParams): Promise<NotificationsResponse> => {
    const response = await api.get<NotificationsResponse>('/notifications/all', {
      params: {
        limit: params?.limit || 50,
        type: params?.type,
        unread_only: params?.unread_only
      }
    })
    return response.data
  },

  getUnreadCount: async (type?: NotificationType): Promise<UnreadCountResponse> => {
    const response = await api.get<UnreadCountResponse>('/notifications/unread-count', {
      params: { type }
    })
    return response.data
  },

  getNotification: async (id: number): Promise<NotificationResponse> => {
    const response = await api.get<NotificationResponse>(`/notifications/${id}`)
    return response.data
  },

  markAsRead: async (id: number): Promise<MarkAsReadResponse> => {
    const response = await api.post<MarkAsReadResponse>(`/notifications/${id}/read`)
    return response.data
  },

  markAllAsRead: async (type?: NotificationType): Promise<MarkAllAsReadResponse> => {
    const response = await api.post<MarkAllAsReadResponse>('/notifications/mark-all-read', {
      type
    })
    return response.data
  }
}
